import {Params} from '@angular/router';

import {Perspective, SortingStrategyId} from '@selpia/shared/models';
import {DateTools} from '@selpia/shared/utils';
import {OptionsState} from '@selpia/options/data-access';

import {OptionParams, PerspectiveParams} from '../models';

export class NavigationHelper {
  static perspectiveChanged(a: Perspective | undefined, b: Perspective): boolean {
    if (!b.focusDimensionLevel) {
      console.info('Invalid perspective', a, b);
      throw new Error('Invalid focusDimensionLevel');
    }
    const levelMatches = a?.focusDimensionLevel.name === b.focusDimensionLevel.name;
    const totalFlagMatches = a?.includeTotal === b.includeTotal;
    const filtersMatch = a?.filterDimensions.length === b.filterDimensions.length &&
      a?.filterDimensions.every(filter => b.filterDimensions.includes(filter));

    return !(levelMatches && totalFlagMatches && filtersMatch);
  }

  static getParamsForPerspective(perspective: Partial<Perspective>): Partial<PerspectiveParams> {
    const levelName = perspective.focusDimensionLevel?.name;

    const date = perspective.date ? DateTools.getDateString(perspective.date) : undefined;

    const filters = perspective.filterDimensions || [];
    const filterParams: Params = {};
    if (filters?.length) {
      filters.forEach(
        filter => filterParams[filter.dimension.code] = filter.code,
      );
    }

    return {
      q: levelName,
      t: perspective.includeTotal ? "true" : "false",
      d: date,
      ...filterParams,
    };
  }

  static getOptionParamsFromUrl(): Partial<OptionParams> {
    const currentParams = new URLSearchParams(document.location.search);
    return {
      p: currentParams.get('p') || undefined,
      m: currentParams.get('m') || undefined,
      s: currentParams.get('s') as SortingStrategyId || undefined,
      c: currentParams.get('c') || undefined
    };
  }

  static getParamsForOptions(options: Partial<OptionsState>): Partial<OptionParams> {
    return {
      p: options.focusPeriod,
      m: options.focusMeasure?.code,
      s: options.sortType,
      c: options.colouringStrategy,
    };
  }
}
